import { FLIGHT_SEARCH_LIST, FLIGHT_MANIFEST_BOARDING, FLIGHT_TRIP_BOARDING, SET_SELECTED_FLIGHT_LEGKEY, ASSIST_QUEUE, SEAT_MAP_TASK, AISLE, WINDOW } from './FlightSearchType'

export const flightSearchCredential=(props)=>
{
    return{
        type:FLIGHT_SEARCH_LIST,
        flightList:props.flightList
    }
}

export const flightManifestBoardingCredential=(props)=>
{
    return{
        type:FLIGHT_MANIFEST_BOARDING,
        flightManifestBoarding:props.flightManifestBoarding
    }
}

export const flightTripBoardingCredential=(props)=>
{
    return{
        type:FLIGHT_TRIP_BOARDING,
        flightTripBoarding:props.flightTripBoarding
    }
}

export const setflightLegKeyCredential=(props)=>
{
    return{
        type:SET_SELECTED_FLIGHT_LEGKEY,
        selectedFlight:props.selectedFlight
    }
}

export const assistQueueCredential=(props)=>
{
    return{
        type:ASSIST_QUEUE,
        assistQueue:props.assistQueue
    }
}

export const seatmapTaskCredential=(props)=>
{
    return{
        type:SEAT_MAP_TASK,
        seatmapTask:props.seatmapTask
    }
}

export const aisleCredential=(props)=>
{
    return{
        type:AISLE,
        seatPreferenceAisle:props.seatPreferenceAisle
    }
}

export const windowCredential=(props)=>
{
    return{
        type:WINDOW,
        seatPreferenceWindow:props.seatPreferenceWindow
    }
}

